const lang = {
  constructionManagement: '案件管理',
  accountManagement: 'アカウント管理',
  operatorAccount: '配下の作業者アカウント',
  editSupervisorTitle: '監督者アカウント編集',
  editOperatorTitle: '作業者アカウント編集',
  case: 'の案件',
  breadcrumOperator: '配下の作業者アカウント',
  addAccount: {
    supervisorAccount: '監督者アカウント',
    addSupervisorAccount: '監督者アカウント追加',
    addOperatorAccount: '作業者アカウント追加',
    mailAddress: 'メールアドレス',
    mailAddressConfirm: 'メールアドレス（確認）',
    accountName: 'アカウント名',
    password: 'パスワード',
    passwordInfo: '６～２０文字の半角の英数字または記号で入力してください。英字と数字の両方を含めてください。',
    reenterPassword: 'パスワード再入力',
    reenterPasswordLabel: 'パスワード</br>再入力',
    reenterPasswordInfo: '確認のため、もう１度同じパスワードを入力してください。',
    directAdmin: '直属の管理者',
    directSupervisor: '直属の監督者',
    termOfService: '利用規約',
    handlePersonalInfo: '個人情報の取り扱い',
    agreeContent: 'に記載している内容に同意します',
    addTo: '追加',
    cancel: 'キャンセル',
  },
  editAccount: {
    listConstruction: '案件への編集・閲覧権限',
    btnSave: '更新',
  },
  listAccount: {
    supervisorManagement: '監督者アカウント管理',
    operatorManagement: '配下の作業者アカウント',
    titleOperator: '作業者アカウント管理',
    linkToSupervisor: '監督者アカウント管理に戻る',
    tblNumber: '番号',
    tblMail: 'メールアドレス',
    tblAccountName: 'アカウント名',
    tblAccountStatus: 'ステータス',
    tblLinkListOperator: '作業者',
    tblMail_AccountName: 'メールアドレス/アカウント名',
    placeholderSearchAccount: 'アカウント名、メールアドレス',
    linkToListOperator: '確認する',
    linkEdit: '編集',
    linkToListOperatorMobile: '配下の作業者を確認する',
    modalDeleteAccountTitle: '削除確認',
    modalDeleteAccountNoti: 'ルクレ太郎</br>が削除されます',
    modalDeleteAccountContent: '削除したアカウントは復元できません。本当に削除してよろしいでしょうか？',
    modalDeleteAccountCancel: '削除しない',
    modalDeleteAccountConfirm: '削除する',
    willBeDelete: 'が削除されます',
  },
  construction: {
    chooseSupervisor: '監督者アカウント選択',
    txtStep1: '監督者を選択します',
    txtStep2: 'その監督者が管理する案件が表示されます',
    constructionListSupervisor: 'の案件管理',
    constructionList: '案件管理',
    constructionManagement: 'ルクレ太郎 の案件',
    placeholderSearchConstruction: '案件名、案件住所、施工者、案件作成者',
    placeholderSearchConstructionMobile: '案件名、住所、施工者、作成者',
    backToSupervisor: '監督者アカウント選択に戻る',
    tblNameConstruction: '案件名',
    tblNameCreator: '案件作成者',
    tblCreated: '案件作成日',
    tblUpdated: '最終更新日',
    tblStatus: 'ステータス ▼',
    tblLog: 'ログ',
    tblParticipate: '案件参加者',
    tblNameConstruction_Creator: '案件名/最終更新日',
    linkToParticipate: '確認する',
    constructionWillBeDelete: '件の案件が削除されます',
    btnAddParticipate: '+案件参加者を追加する',
  }
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/accountRole.js